import React from 'react';
import ReactNotification from 'react-notifications-component';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';

const App: React.FC = () => {
  return (
    <div style={{ height: "100%" }}>
      <ReactNotification />
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </div>
  );
};

export default App;